// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.shared

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.shared.WalletBackendException
import org.multipaz.rpc.handler.RpcExceptionMap
import org.multipaz.cbor.Bstr
import org.multipaz.wallet.shared.WalletBackendAlreadySignedInException
import org.multipaz.wallet.shared.WalletBackendEncryptionKeyMismatchException
import org.multipaz.wallet.shared.WalletBackendIdTokenException
import org.multipaz.wallet.shared.WalletBackendNonceException
import org.multipaz.wallet.shared.WalletBackendNotSignedInException
import org.multipaz.wallet.shared.WalletBackendSharedDataTooLargeException
import org.multipaz.wallet.shared.WalletBackendVerificationLinkExpiredException
import org.multipaz.wallet.shared.toDataItem
import org.multipaz.wallet.shared.fromDataItem

fun WalletBackendException.Companion.register(exceptionMapBuilder: RpcExceptionMap.Builder) {
    exceptionMapBuilder.addException<WalletBackendException>(
        "WalletBackend",
        { exception ->
            exception.toDataItem()
        } ,
        { dataItem ->
            WalletBackendException.fromDataItem(dataItem)
        } ,
        listOf(
            WalletBackendException::class,
            WalletBackendAlreadySignedInException::class,
            WalletBackendEncryptionKeyMismatchException::class,
            WalletBackendIdTokenException::class,
            WalletBackendNonceException::class,
            WalletBackendNotSignedInException::class,
            WalletBackendSharedDataTooLargeException::class,
            WalletBackendVerificationLinkExpiredException::class,
            )
    )
}
